import React, { useState } from 'react';
import { api } from '../api.js';

export default function Login({ onAuthed }) {
  const [pw, setPw] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr(''); setBusy(true);
    try {
      await api('/api/auth/login', { method: 'POST', body: { password: pw } });
      onAuthed();
    } catch (e) {
      setErr(e.status === 401 ? 'Wrong password.' : 'Failed.');
    } finally { setBusy(false); }
  }

  return (
    <div style={{ maxWidth: 420, margin: '14vh auto', padding: 40, background: 'var(--panel)', border: '1px solid var(--rule)' }}>
      <h1 style={{ fontFamily: 'var(--font-sans)', fontWeight: 500, fontSize: 36, margin: '0 0 6px' }}>
        The Workshop<span style={{ color: 'var(--accent)' }}>.</span>
      </h1>
      <p style={{ fontFamily: 'var(--font-sans)', fontStyle: 'italic', color: 'var(--ink-2)', margin: '0 0 28px' }}>
        Enter to open the room.
      </p>
      <form onSubmit={submit}>
        <label htmlFor="pw" style={{ fontFamily: 'var(--font-mono)', fontSize: 10.5, letterSpacing: '0.08em', textTransform: 'uppercase', color: 'var(--ink-3)' }}>password</label>
        <input id="pw" type="password" value={pw} onChange={e=>setPw(e.target.value)} autoFocus
          style={{ display:'block', width:'100%', padding:12, marginTop:8, background:'var(--panel-2)', color:'var(--ink)', border:'1px solid var(--rule)', borderRadius:2, fontSize:16, boxSizing:'border-box' }} />
        <button type="submit" disabled={busy || !pw}
          style={{ marginTop:20, width:'100%', padding:12, background:'var(--ink)', color:'var(--bg)', border:0, cursor:'pointer', fontFamily:'var(--font-mono)', textTransform:'uppercase', letterSpacing:'0.08em', fontSize:12, opacity: busy || !pw ? 0.5 : 1 }}>
          Open the room
        </button>
        {err && <div style={{ marginTop:16, color:'var(--accent)', fontSize:13 }}>{err}</div>}
      </form>
    </div>
  );
}
